// extracted by mini-css-extract-plugin
export default {"companyContainer":"NJ-z","companyImage":"OJ-z","container":"PJ-z","heading":"QJ-z","darkText":"RJ-z","smallHeading":"SJ-z","darkBackground":"TJ-z","whiteBackground":"UJ-z"};